module.exports = __webpack_public_path__ + "img/Asset 26.fc232ef1.png";